import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  selected_tab: any = 1;
  constructor() { }

  ngOnInit(): void {
  }
  selectTab(tab){
    this.selected_tab = tab
  }

}
